'use strict';

namespace TR {

    import IScope = angular.IScope;
    import ResourceService = Core.ResourceService;
    import TransferQuote = Core.Transfers.TransferQuote;
    import SelectedTransfer = Core.Transfers.SelectedTransfer;

    interface RouteParams extends ng.route.IRouteService {
        tripId: string;
        productId: string;
    }

    class CrossSellTransfers {
        transfersEnabled: boolean;

        private isHotelJourney: boolean;

        readonly emptyTransfer: SelectedTransfer;
        readonly noneTransfer: SelectedTransfer;
        nullTransferText: () => string;

        showInitialMessage: boolean = false;
        transfersAvailabilityBusy: boolean = true;
        transfersSelectionBusy: boolean = true;

        transfer: SelectedTransfer;
        private transfers: TransferQuote[];
        rankedResults: TransferQuote[];

        total: number = 0;

        showDetailsError: boolean;

        private basketId: undefined | string;
        // TODO remove code related to var isTransferMandatory it is old functionality
        isTransferMandatory: boolean;
        mandatoryExtrasEnabled: boolean = false;
        isMandatoryExtra: boolean = false;
        private mandatoryTransfer: any;
        private bookedMandatoryOptions: any;
        hotelName: string;
        isAvailableTransfer: boolean;
        private transferQuoteDescription: string;
        private hotelData: any;
        private roomsWithMandatoryTransfer: any;
        private hotelExtrasSelectedTransfer: any;
        private hotelExtrasMandatoryTransfers: any[];
        private hotelProductId: string;
        private OptionId: string;

        constructor(private $q :ng.IQService,
                    private $routeParams :RouteParams,
                    private $scope: IScope,
                    private analytics,
                    private basketService,
                    private basketStore,
                    private hotelFromSession,
                    private broker: Core.Broker,
                    private customCurrencyFilter,
                    private resourceService: Core.ResourceService,
                    private tripService: Core.TripService,
                    private mandatoryTransferService,
                    private hotelRoomService) {
            this.noneTransfer = { Details: { TransferId: '-1' } };
            this.emptyTransfer = { Details: { TransferId: null } };
            this.mandatoryExtrasEnabled = TRPCONFIG.Domain.MandatoryExtrasEnabled;
            this.mandatoryTransfer = [];
            if (this.isHotelJourney) {
                this.showInitialMessage = true;
                this.transfersAvailabilityBusy = false;
            }
            broker.subscribe('Transfers', 'ProductHotelReceivedFromBasket', e => {
                this.basketId = e.data.basketId;
                this.hotelProductId = e.data.productId;
            });

            $scope.$watch('tran.hotelExtrasSelectedTransfer', (val: any) => {
                if(val && this.hotelProductId && this.basketId) {
                    this.OptionId = this.mandatoryTransferService
                                        .generateOptionId(undefined, val.HotelExtraId, val.HotelExtraOptionId);
                    const type = 2;
                    basketStore.addOption(type, this.hotelProductId, this.OptionId, this.basketId)
                    .then(()=>{
                        const hemt = this.hotelExtrasMandatoryTransfers;
                        const hest = this.hotelExtrasSelectedTransfer;
                        const options = this._getExpiredOptions(hemt, hest);
                        basketStore.removeOptions(type, this.hotelProductId, options, this.basketId).then(() => {
                            basketService.updateBasket();
                        });
                    });
                }
            });

            broker.subscribe('Transfers', 'transferRequestFailed', () => {
                this.showDetailsError = true;
                if (!this.isTransferMandatory) {
                    this.transfer = angular.copy(this.noneTransfer);
                }
            });

            $scope.$on('$destroy', () => {
                broker.unsubscribe('Transfers');
            });

            tripService.getTrip($routeParams.tripId).then((trip: Core.Trip.TripState) => {
                this.basketId = trip.BasketId;
                const tripId = trip.TripId;
                let transferSearchId: string = _.get<string>(trip, 'TransfersRequest.AvailabilitySearchId');

                $q.all([
                    basketStore.transfer(this.basketId, $routeParams.productId),
                    basketStore.hotel(this.basketId, $routeParams.productId)
                ]).then(results => {
                    const transfer = results[0] || this.noneTransfer;
                    $scope.$emit('sendTransferSelection', transfer);
                    this.transfer = angular.copy(transfer);

                    const hotel = results[1];

                    if (this.mandatoryExtrasEnabled && hotel) {
                        this.hotelFromSession.getHotel(hotel.AvailabilitySearchId, hotel.Details.Id, tripId)
                                             .then(res => {
                            this.hotelData = angular.copy(res);
                            if (this.hotelData){
                                this._initMandatoryTransfers(hotel, trip);
                            }
                        });
                    }

                    this.transfersEnabled = _([this.tripService.tripTypes.Holiday, this.tripService.tripTypes.Hotel])
                            .includes(trip.TripType) && hotel && !hotel.isVilla;


                    const getTransfers = (transferSearchId: null | string, params) => {
                        basketService.getTransfers(transferSearchId, this.basketId, tripId, params).then((r) => {
                            if (r && r.length > 0 && this.isTransferMandatory) {
                                this.transfer.Details.TransferId = r[0].TransferId;
                            }
                            this.setResults(r, hotel);
                        });
                    };


                    if (this.isHotelJourney) {
                        broker.subscribe('Transfers', 'flightDataUpdated', e => {
                            this.transfersAvailabilityBusy = true;
                            this.transfer = angular.copy(this.noneTransfer);
                            getTransfers(null, e && e.data);
                        });
                    }

                    if (transferSearchId || !this.isHotelJourney) {
                        getTransfers(transferSearchId, {});
                    }

                    if (hotel && trip.FlightsRequest && trip.FlightsRequest.Destination) {
                        this._checkIstransferMandatory(trip.FlightsRequest);
                    }

                    if (this.mandatoryExtrasEnabled) {
                        this._setMandatoryTransferWatcher(trip, hotel);
                    } else {
                        this._setTransfersWatcher(trip, tripId, transferSearchId);
                    }

                }).then(angular.noop, basketService.restartHolidayWorkflow);
            }, basketService.bookingAlreadyDone);

        }

        _getExpiredOptions(transfers, currentTransfer) {
            let expiredOptionsIds = Array();
            if(currentTransfer && transfers.length && transfers.length > 0) {
                let expiredTransfers = transfers.filter(t => {
                    return t.HotelExtraId === currentTransfer.HotelExtraId
                        && t.HotelExtraOptionId !== currentTransfer.HotelExtraOptionId;
                });
                expiredTransfers.forEach(et => {
                    let OptionId = this.mandatoryTransferService
                                      .generateOptionId(undefined, et.HotelExtraId, et.HotelExtraOptionId);
                    expiredOptionsIds.push({OptionId});
                });
            }
            return expiredOptionsIds;
        }

        private transferQuoteDescriptionWithPrice: string;

        setResults(r, hotel) {

            if (r != null) {
                this.transfers = <TransferQuote[]>_.sortBy(r, 'TotalPrice');
                this._updateSubtitle();
                //so that we can test both versions of the page
                // we need to create a secondary limited list of transfers to use on the new design
                this.rankedResults = <TransferQuote[]>_.sortBy(_.take(r, 3), 'TotalPrice');
                this.isAvailableTransfer = (this.rankedResults && this.rankedResults.length > 0) ||
                                            this.showInitialMessage;
            }

            if (hotel != null) {
                const hotelDetails = _.get(hotel, 'Details');
                const bookedItems = _.get(hotelDetails, 'BookedItems');
                const mandatoryTransfers = _.get(bookedItems[0], 'mandatoryTransfers');
                if (mandatoryTransfers) {
                    this.isAvailableTransfer = true;
                }
            }

            if (TRPCONFIG.Domain.EnforceTransferOptionSelection && this.isNoneTransfer(this.transfer)) {
                this.transfer = angular.copy(this.emptyTransfer);
            }

            this.transfersAvailabilityBusy = false;

            //tracking
            if (r != null && r.length > 0) {
                this._trackingTransferSelection(this.transfer.Details.TransferId);
            } else {
                this.analytics.track('mixpanel', 'OptionsTransferNoAvailability');
            }

        }

        isNoneTransfer(transfer :SelectedTransfer) :boolean {
            return angular.equals(transfer, this.noneTransfer);
        }

        _setMandatoryTransferWatcher(trip, hotel) {
            if (this.tripService.supportsTransfers(trip)) {
                this.$scope.$watchCollection('tran.mandatoryTransfer', () => {
                    const transfersWrapper = {transfers: this.mandatoryTransfer};
                    const options = this.mandatoryTransferService
                    .generateOptionsForMultiRooms(transfersWrapper,
                        this.roomsWithMandatoryTransfer);
                    this._changeMandatoryTransfer(options, hotel);
                });
            }
        }

        _setTransfersWatcher(trip, tripId, transferSearchId) {
            if (this.tripService.supportsTransfers(trip)) {
                this.$scope.$watch('tran.transfer.Details.TransferId', (val) => {
                    if (TRPCONFIG.Domain.EnforceTransferOptionSelection) {
                        if (this.transfers && this.transfers.length > 0) {
                            this.$scope.$emit('sendTransferSelection', val);
                        }
                        else {
                            this.$scope.$emit('sendTransferSelection', this.noneTransfer);
                        }
                    }
                    if (val == null) {
                        return;
                    }
                    this.$scope.$emit('flash:hide');
                    this.transfersSelectionBusy = true;
                    if (this.transfers && this.transfers.length > 0) {
                        this._trackingTransferSelection(val);
                    }
                    this._updateSubtitle();

                    if (val !== this.noneTransfer.Details.TransferId) {
                        //we need to re-check the trip here in case we have just generated the search id
                        this.tripService.getTrip(tripId).then((t) => {
                            transferSearchId = _.get<string>(t, 'TransfersRequest.AvailabilitySearchId');
                            this.basketService.selectTransfer(val, transferSearchId, this.basketId, tripId)
                                .then(() => {
                                    this.basketService.updateBasket();
                                    this.showDetailsError = false;
                                    this.transfersSelectionBusy = false;
                                });
                        });
                    } else {
                        this.basketStore.removeTransfer(this.basketId).then(this.basketService.updateBasket);
                        this.transfersSelectionBusy = false;
                    }
                });

                this.nullTransferText = this.resourceService.getDeferred('NOTRANSFERREQUIRED');
            }
        }

        _trackingTransferSelection(transferId) {
            const data: any = {
                Title: null,
                CostPP: null,
                CostTotal: null,
                OptionIndex: null,
                TotalOptions: this.transfers.length + 1, //+1 for 'no transfer' options
                MinOptionCostTotal: _.first(this.transfers).TotalPrice,
                MaxOptionCostTotal: _.last(this.transfers).TotalPrice,
                HotelAndFlightCost: null,
                SupplierName: null
            };

            if (transferId == null) {
                data.Title = 'Nothing selected';
            } else if (transferId !== '-1') {
                let index = 0;
                const quote = _.find(this.transfers, (t, i) => {
                    index = i;
                    return angular.equals(t.TransferId, transferId);
                });

                data.Title = quote.Type;
                data.CostPP = quote.PerPersonPrice;
                data.CostTotal = quote.TotalPrice;
                data.OptionIndex = index + 1; //0-based index will confuse end user
                data.SupplierName = quote.SupplierName;
            } else if (transferId === '-1') {
                data.Title = 'No Transfer';
            }

            this.$q.all([
                this.basketStore.hotelCost(this.basketId),
                this.basketStore.flightCost(this.basketId)
            ]).then(res => {
                data.HotelAndFlightCost += res[0] + res[1];
                this.analytics.track('mixpanel', 'OptionsTransferSelected', data);
            });
        }

        _updateSubtitle() {
            if (this.transfers && this.transfer.Details.TransferId) {
                const transferQuote = _.find(this.transfers, (t) => {
                    return angular.equals(t.TransferId, this.transfer.Details.TransferId);
                });
                this.total = transferQuote ? transferQuote.TotalPrice : 0;
                this.transferQuoteDescription = transferQuote
                    ? `${transferQuote.Quantity} x ${transferQuote.Type}`
                    : '';
                this.transferQuoteDescriptionWithPrice = transferQuote
                    ? `${this.transferQuoteDescription} (${this.customCurrencyFilter(this.total)})`
                    : '';
            }
        }

        _checkIstransferMandatory(flight) {
            const destinationAiports = flight.DestinationAirports ? flight.DestinationAirports
                                       : flight.Destination.DestinationAirports.split(',');
            this.isTransferMandatory = destinationAiports.includes(...TRPCONFIG.Domain.IsTransferMandatory);
        }

        _initMandatoryTransfers(hotel, trip) {
            this.roomsWithMandatoryTransfer = this.mandatoryTransferService
            .getHolidayRoomsWithTransfers(hotel.Details) || [];
            this.roomsWithMandatoryTransfer.length > 0 ? this.transfersSelectionBusy = false : null;
            this.bookedMandatoryOptions = [];
            for(let i = 0; i < this.roomsWithMandatoryTransfer.length; i++) {
                this.bookedMandatoryOptions = this.mandatoryTransferService
                .getSelectedTransfers(hotel, this.roomsWithMandatoryTransfer);
                this.mandatoryTransfer[i] = this.bookedMandatoryOptions[i]
                || this.roomsWithMandatoryTransfer[i].mandatoryTransfers[0];
            }
            if (this.mandatoryTransfer.length > 0 || this.roomsWithMandatoryTransfer.length > 0)  {
                this.isAvailableTransfer = true;
            }
            if (this.roomsWithMandatoryTransfer.length === 0) {
                const tripId = trip.TripId;
                let transferSearchId: string = _.get<string>(trip, 'TransfersRequest.AvailabilitySearchId');
                this._setTransfersWatcher(trip, tripId, transferSearchId);
            }
            if (this.bookedMandatoryOptions && this.bookedMandatoryOptions.length > 0) {
                this.bookedMandatoryOptions = this.mandatoryTransferService
                                                .generateOptionsForMultiRooms({transfers: this.bookedMandatoryOptions},
                                                    this.roomsWithMandatoryTransfer);
            }
        }
        _changeMandatoryTransfer(options, hotel) {
            if (options.length > 0 && JSON.stringify(this.bookedMandatoryOptions) !== JSON.stringify(options)) {
                const productType = this.basketStore.productType.Transfer;
                const productId = hotel.ProductId;
                this.basketStore.removeOptions(productType, productId, this.bookedMandatoryOptions, this.basketId)
                    .then(() => {
                        this.bookedMandatoryOptions = options;
                        this.basketStore.addOptions(productType, productId, options, this.basketId)
                            .then(() => this.basketService.updateBasket());
                });
            }
        }
    }

    angular
        .module('TR')
        .component('crossSellTransfers', {
            bindings: {
                isHotelJourney: '<',
                isTransferMandatory: '=?',
                isAvailableTransfer: '=?',
                isMandatoryExtra: '@'
            },
            controller: CrossSellTransfers,
            controllerAs: 'tran',
            templateUrl: 'partials/home/directivetemplate?type=CrossSellTransfers'
        });
}
